import { createAction } from 'typesafe-actions';

export const appInit = createAction('APP | INIT')();

export const appDestroy = createAction('APP | DESTROY')();
